<template>
  <div class="game">
    <div class="game__title">
      <img src="../assets/icons/game.svg" alt="" srcset="" /> Chọn game
    </div>
    <v-row>
      <v-col cols="12" md="6" v-for="(game, index) in games" :key="index">
        <div @click="gameClick(game)" class="game-item">
          <div class="game-item__image">
            <img
              :src="
                game.icon.replace(
                  'https://vgplay.vn/uploads/',
                  'https://img.vgplay.vn/vgplay/'
                )
              "
              alt=""
            />
          </div>
          <div class="game-item__text text-left">
            {{ game.name }}
            <span class="game-item__type d-block">{{ game.type }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Game } from '../services/functions'

export default {
  name: 'GameComp',
  created() {
    this.$store.dispatch('GAME_REQUEST')
  },
  computed: {
    ...mapGetters(['GAMES']),
    ...mapState(['games']),
    games() {
      return this.$store.getters.GAMES
    },
  },
  methods: {
    gameClick: Game.gameClick,
  },
}
</script>

<style lang="scss" scoped></style>
